import React from 'react';
import { FormLayout, SignOutHandler } from '../../containers';

const SignOutHandlerPage: React.FC = () => {
    return (
        <FormLayout>
            <SignOutHandler />
        </FormLayout>
    );
};

/**
 * Название компонента, используемое при отладке.
 */
SignOutHandlerPage.displayName = 'ExternalSystemAuthorizationHandlerPage';

export default SignOutHandlerPage;
